module.exports = __webpack_public_path__ + "img/map_search_info_icon03.16b4654b.svg";